import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController} from 'ionic-angular';

import { MarketplaceAddPage } from '../marketplace-add/marketplace-add';
import { MarketplaceItemPage } from '../marketplace-item/marketplace-item';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';
/**
 * Generated class for the MarketplacePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-marketplace',
  templateUrl: 'marketplace.html',
})
export class MarketplacePage {
  title: string = 'Schwarzes Brett';
  segments: any = 'all';
  items: any;
  chooseCategory: any = -1;
  chooseCategoryHeadline: string = '';
  constructor(private alertCtrl: AlertController, public userProvider: UserProvider, public navCtrl: NavController, public navParams: NavParams, public teamappProvider: TeamappProvider) {
      if(this.navParams.get("title")) {
          this.title = this.navParams.get("title");
      }

  }

  addNew() {
      this.navCtrl.push(MarketplaceAddPage, {title: this.title+': Inserieren'});
  }

  openItem(id: any) {
      this.navCtrl.push(MarketplaceItemPage, {id: id, title: this.title});
  }

  ionViewDidEnter() {
      this.loadItems();
  }

  loadItems() {
      this.teamappProvider.http_request('action=get_items', 'marketplace', false, true).then(data => {
          this.items = data;
          console.log(data);
      });
  }

  changeCategory() {
      let choose: any = [];

      if(this.chooseCategory == -1) {
          choose.push( {
              type: 'radio',
              id: -1,
              name: 'Alle Kategorien',
              label: 'Alle Kategorien',
              value: -1,
              checked: true
          });
      } else {
          choose.push( {
              type: 'radio',
              id: -1,
              name: 'Alle Kategorien',
              label: 'Alle Kategorien',
              value: -1,
              checked: false
          });
      }

      for(let i = 0; i<this.items.categorys.length;i++) {
          console.log(this.items.categorys);
          if(this.chooseCategory == this.items.categorys[i].id) {
              choose.push( {
                  type: 'radio',
                  id: this.items.categorys[i].id,
                  name: this.items.categorys[i].name,
                  label: this.items.categorys[i].name,
                  value: this.items.categorys[i].id,
                  checked: true
              });
          } else {
              choose.push( {
                  type: 'radio',
                  id: this.items.categorys[i].id,
                  name: this.items.categorys[i].name,
                  label: this.items.categorys[i].name,
                  value: this.items.categorys[i].id,
                  checked: false
              });
          }

      }

      let myAlert = this.alertCtrl.create({
          title: 'Kategorien',
          enableBackdropDismiss: true ,
          buttons:[
              {
                  text: 'OK',
                  handler: data => {
                        this.chooseCategory = data;
                        console.log(this.items.categorys[data]);

                        for(let i = 0; i<this.items.categorys.length;i++) {
                            if(this.items.categorys[i].id == data) {
                                this.chooseCategoryHeadline = this.items.categorys[i].name;
                            }
                        }

                  },
                  role: ''
              },
              {
                  text: 'Abbrechen',
                  handler: data => {

                  },
                  role: 'cancel'
              }
          ],
          inputs: choose
      });
      myAlert.present();
  }

  formatPrice(price: string) {
      return price.replace('.', ',');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MarketplacePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/marketplace/marketplace.ts